import { FC, memo } from 'react'
// import { Box } from '@chakra-ui/react'
import { createIcon } from '@chakra-ui/icons'

import { CustomIconProps } from 'types'
import CustomIcon from '../../CustomIcon'

const FolderCheckmarkOutline = createIcon({
  displayName: 'FolderCheckmarkOutline',
  viewBox: '0 0 24 24',
  path: (
    <>
      <g strokeLinecap="round" strokeWidth="1.5" stroke="currentColor" fill="none" strokeLinejoin="round">
        <path d="M19,6.94h-6.471c-0.331,0 -0.641,-0.164 -0.827,-0.438l-1.405,-2.065c-0.186,-0.273 -0.495,-0.437 -0.826,-0.437h-4.471c-1.105,0 -2,0.895 -2,2v12c0,1.105 0.895,2 2,2h14c1.105,0 2,-0.895 2,-2v-9.06c0,-1.104 -0.895,-2 -2,-2Z"></path>
        <path d="M14.889,12.056l-3.611,3.611l-2.167,-2.167"></path>
      </g>
      <path fill="none" d="M0,0h24v24h-24v-24Z"></path>
    </>
  ),
})

const FolderCheckmark: FC<CustomIconProps> = (props) => {
  // if (props.variant === 'twoTone') return <CustomIcon as={FolderCheckmarkTwoTone} {...props} />

  return <CustomIcon as={FolderCheckmarkOutline} {...props} />
}

export default memo(FolderCheckmark)
